/**
 * Keep all the hardcoded values here.
 * Don't keep the constants here which will change depends on environment use environment files for that.
 */

// api endpoints mapping.
const apiMapping = {
  GET_USER_LIST: 'users',
  SEARCH_USERS: 'users/search',
  ADD_USER: 'add-user',
  ADD_CUSTOMER: 'add-customer',
  UPDATE_CUSTOMER: 'update-customer',
  LIST_OF_PROFILES: 'roles',
  LIST_OF_PROFILES_FOR_USER: 'roles/user',
  ADD_PROFILE: 'role',
  DELETE_PROFILES: 'role',
  GET_RESOURCES_LIST: 'resources',
  GET_APPLICATIONS_LIST: 'applications',
  GET_CUSTOMERS_LIST: 'customers',
  DELETE_APPLICATION: "application/REPLACE_APP_ID",
  APP_LIST: 'applications',
  ROLE_RSC_LIST: 'role/REPLACE_ROLE_ID/resources',
  APP_RSC_LIST: 'application/REPLACE_APP_ID/permissions',
  GET_USER_PERMISSIONS: 'user-permissions',
  UPDATE_PROFILE: 'role/REPLACE_ROLE_ID',
  DELETE_USER: 'user',
  LOGIN: 'login',
  GET_SCOPE_TYPES: 'scope/categories',
  GET_SCOPE_NAMES_UNDER_TYPE: 'scope/REPLACE_SCOPE_TYPE/values',
  GET_SCOPE_VALUES_OF_TYPE: 'scope/REPLACE_SCOPE_TYPE/names/REPLACE_SCOPE_NAME/values',
  UPDATE_USER: 'update-user',
  CHANGE_PASSWORD: 'change-password',
  OTP_SEND: 'otp/send',
  RESET_PASSWORD: 'reset-password',
  KEYCLOAK_RESET_PASSWORD : 'reset-user-password',
  GET_CSRF_TOKEN : 'generate-csrf-token',
  KEYCLOAK_DELETE_USER : 'delete-user',

  FETCH_USER_INFO_BY_ID : 'userInfo',
  GET_ROLE_INFO_BY_ID : 'role-details',

  GET_ALL_ACTIVE_APPLICATIONS : 'applicationsList',
  ASSIGN_UPDATE_CUSTOMER_APPLICATIONS : 'assign-update-applications',

  FETCH_ALL_ASSIGNED_RESOURCES_FOR_ASSIGNED_APPLICATIONS : 'resourceTypes/assignedResources/assignedApps',
  FETCH_ALL_RESOURCES_FOR_ASSIGNED_APPLICATIONS : 'resourceTypes/resources/assignedApps',
  FETCH_ALL_RESOURCES_UNDER_RESOURCE_TYPE : 'resourceTypes/resources',
  FETCH_RESOURCES_BY_APPLICATION_ID : 'resources/resourceTypes',
  FETCH_ALL_RESOURCES_BY_RESOURCE_TYPE_UNDER_APPLICATION : 'resourceTypes/resources',
  FETCH_ASSIGNED_RESOURCES_FOR_CUSTOMER : 'resourceTypes/resources/assignedResources',

  FETCH_ASSIGNED_APPLICATION_LIST_FOR_CUSTOMER : 'assignedApplications',
  FETCH_CUSTOMER_ADMIN_INFO_BY_CUSTOMER_ID : 'customerAdminInfo',

  ASSIGN_OR_UPDATE_RESOURCES : 'applications/resources',
  ASSIGN_RESOURCE_TO_CUSTOMERS: "customers/assign-resource",
  ASSIGN_RESOURCE_TO_ROLES : "roles/assign-resource",
  UNASSIGN_APPLICATION_FOR_CUSTOMER : "unassign-application",

  DELETE_CUSTOMER: "delete-customer",
  ACTIVATE_CUSTOMER: 'activate-customer',
  DEACTIVATE_CUSTOMER: 'deactivate-customer',
  SEARCH_CUSTOMERS_BY_NAME : "customers/name-search",
  FETCH_CUSTOMER_ATTRIBUTES : "get-customer",

  // APPLICATION API FOR CUSTOMER TYPE
  FETCH_CUSTOMER_TYPE: 'maintenanceAgency/customerType/list',
  ADD_CUSTOMER_TYPE: 'types/updateCustomerType',
  SET_CUSTOMER_DETAILS: 'alertConfiguration/deleteCustUuidFromAlertConfig',
  PRIVATE_BLOB_CONTAINER: '/platform/stream_file',
  STREAM_FILE:'/stream_file'
}


const preDefinedResources = ["USER", "APPLICATION", "RESOURCE", "ACTION", "ROLE", "CUSTOMER", "LOGIN"];

const keycloakErrorMessages = {
  incomingMobileNoError : 'Duplicate entry',
  displayedmobileNoErrorMsg : 'The Mobile Number already exists'
}


const operationTypes = {
  CUSTOMER: {
    ADD_CUSTOMER: 'add_customer',
    EDIT_CUSTOMER: 'edit_customer',
    DELETE_CUSTOMER: 'delete_customer'
  },
  PROFILE: {
    ADD_PROFILE: 'add_profile',
    EDIT_PROFILE: 'edit_profile',
    DELETE_PROFILE: 'delete_profile'
  },
  USER: {
    ADD_USER: 'add_user',
    EDIT_USER: 'edit_user',
    DELETE_USER: 'delete_user',
  },
  ALLOCATE_APPLICATIONS : {
    ASSIGN_APPLICATIONS : 'Assign Applications',
    UPDATE_APPLICATIONS : 'Update Applications'
  },
  ALLOCATE_RESOURCES : {
    ASSIGN_RESOURCES : 'Assign Resources',
    UPDATE_RESOURCES : 'Update Resources',
    ASSIGN_RESOURCES_TITLE : 'Assign Resources For Applications',
    UPDATE_RESOURCES_TITLE : 'Update Resources For Applications'
  }
}

export const PUBLIC_KEY_FOR_DECRYPTION = 'LhqfD49Mg2LCmpGwKIAmryPhw993Pq60'

const infiniteScrollOptions = {
  SCROLL_LIMIT : 2,
  SCROLL_DISTANCE: 2,
  THROTTLE: 50,
  SCROLL_ON_WINDOW: false,
  INFINITE_SCROLL_DISABLED: false,
  INFINITE_SCROLL_LIMIT : 20
}

const OPTIONS = {
  VIEW: 'View',
  EDIT: 'Edit',
  DELETE: 'Delete'
};

const CONTENT_OPTIONS = {
  'customer': 'Customer',
  'roles': 'Role',
  'profiles': 'Role',
  'administrators': 'Administrator',
  'users': 'User',
  'applications': 'Application',
  'resources': 'Resource',
  'actions': 'Action'
}


const resourceTypes = ["APIs", "URLs", "Dashboards", "Widgets", "Channels", "Others"];

const resourceTypesMap = {
  "API": "APIs",
  "URL": "URLs",
  "DASHBOARD": "Dashboards",
  "WIDGET": "Widgets",
  "CHANNEL": "Channels",
  "Others": "Others"
}

const ROLES = [{ label: 'Read', value: 'Read', isChecked: false },
{ label: 'Write', value: 'Write', isChecked: false },
{ label: 'Approve', value: 'Approve', isChecked: false }];


const COMMON_ROUTE_MAPPING = {
  LOGIN: ['username'],
  SIGNIN: ["usermgmt", "authentication", "signIn"],
  USERPAGE: ["usermgmt", "users"]
}


const LIST_NAME_MAPPING = {
  USER_LIST: 'userlist',
  ROLE_LIST: 'rolelist',
  PROFILE_LIST: 'profilelist',
  ADMIN_LIST: 'adminlist',
  CUSTOMER_LIST: 'customerlist',
  CUSTOMER_INACTIVE_LIST: 'customerInAcivelist',
  RESOURCE_LIST: ' resourcelist',
  ACTION_LIST: 'actionlist',
  PROFILE_CUSTOMER_LIST: 'profilelistcustomer',
  USER_CUSTOMER_LIST: 'usercustomerlist'

}

const STATUS_TYPE_LIST = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive'
}

const customerAdminRoleName = 'Customer Administrator';
const customerServiceExecutive = 'Customer Service Executive';


const LANDING_PAGE_RESOURCE = 'LANDING-PAGE'
const intialCountry = { "name": "United States", "dial_code": "+1", "code": "US", "flag": "https://flagcdn.com/w320/us.png" }
const validationTimer = 20

const userManagementApplicationName = 'User Management';

const superAdmin = 'Super Administrator';

const domainsRequiringUserId = ['get_user_permissions'];

const ORDER_FOR_VIEW_USERS = {
  "activationDate" : 5,
  "email" : 3,
  "firstName" : 1,
  "lastName" : 2,
  "lastLogin" : 6,
  "status" : 7,
  "username" : 8,
  "mobileNumber" : 9,
  "title" : 4
}

const EDIT_USER_ADD_ROLE= {
  "d9168e72-9bc7-4627-854e-dec9e6952fb1": {
      "scope": [
          {
              "scopeType": "NON_HIERARCHY",
              "scopeName": "Application",
              "scopeValue": []
          }
      ]
  }
}

const errorMessages = {
  'CUST_ADMIN_GENERAL' : 'Error occured while creating organization admin'
}

const customerModuleOperations = {
  'ADD_CUSTOMER' : 'new',
  'UPDATE_CUSTOMER': 'edit',
  'VIEW_CUSTOMER': 'view'
}

const userModuleOperations = {
  'ADD_USER' : 'new',
  'UPDATE_USER': 'edit',
  'VIEW_USER': 'view'
}

const roleModuleOperations = {
  'ADD_ROLE' : 'new',
  'UPDATE_ROLE': 'edit',
  'VIEW_ROLE': 'view'
}

const conflictString = "Conflict:";

const actionNameMapping = {
  READ: "R",
  EDIT: "E"
}

const loggedInUserTypes = {
  superAdmin: 'superAdmin',
  organizationAdmin: 'organizationAdmin',
  organizationUser: 'organizationUser'
};

const userPermissionAction = {
  READ: "READ",
  EDIT: "EDIT",
  NO_ACCESS: 'NO-ACCESS'
}

const dimenstionTypeCnst = {
  INTENT: 'INTENT',
  GEOGRAPHY: 'GEOGRAPHY',
  CUSTOMER_TIER: 'CUSTOMER_TIER'
}


const loggedInUserTypeKey = "loggedInUserType";
const organizationInfoKey = "organizationInfo";
const applicationInfoKey = 'applicationInfo';
const fieldEngineer = "FieldEngineer";
const HR = "HR";
const triggerDetailsInfoKey = 'triggerDetails';
const realDetailsKey = 'realmDetails';

export const USER_MGMT_CNST = {
  API_MAPPING: apiMapping,
  INFINITE_SCROLL_OPTIONS: infiniteScrollOptions,
  OPTIONS: OPTIONS,
  COMMON_ROUTE_MAPPING,
  ROLES,
  CONTENT_OPTIONS,
  LIST_NAME_MAPPING,
  OPERATION_TYPES: operationTypes,
  STATUS_TYPE_LIST,
  CURRENT_USERMANAGEMENT_APPLICATION: userManagementApplicationName,
  KEYCLOAK_ERROR_MSGS : keycloakErrorMessages,
  DOMAINS_NEEDING_USER_ID: domainsRequiringUserId,
  VALIDATION_CONSTANT: validationTimer,
  ORDER_FOR_VIEW_USERS,
  SUPER_ADMIN: superAdmin,
  CUSTOMER_ADMIN_ROLE : customerAdminRoleName,
  CUSTOMER_SERVICE_EXECUTIVE : customerServiceExecutive,
  EDIT_USER_ADD_ROLE,
  PREDEFINED_RESOURCES : preDefinedResources,
  RESOURCE_TYPES : resourceTypes,
  RESOURCE_TYPES_MAP : resourceTypesMap,
  ERROR_MESSAGES : errorMessages,
  CONFLICT_STRING : conflictString,
  CUSTOMER_MODULE_OPERATIONS : customerModuleOperations,
  USER_MODULE_OPERATIONS : userModuleOperations,
  ROLE_MODULE_OPERATIONS : roleModuleOperations,
  ACTION_NAME_MAPPING: actionNameMapping,
  LOGGED_IN_USER_TYPES: loggedInUserTypes,
  LOGGED_IN_USER_TYPE_KEY: loggedInUserTypeKey,
  ORGANIZATION_INFO_KEY: organizationInfoKey,
  APPLICATION_INFO_KEY: applicationInfoKey,
  REALM_DETAILS_KEY: realDetailsKey,
  USER_PERMISSION_ACTION : userPermissionAction,
  DIMENSION_TYPE_CONST : dimenstionTypeCnst,
  FIELD_ENGINEER : fieldEngineer,
  HR: HR,
  LANDING_PAGE_RESOURCE:LANDING_PAGE_RESOURCE,
  TRIGGER_DETAILS_INFO_KEY: triggerDetailsInfoKey,
  SYSTEM_ROLES: ['designer', 'verifier', 'approver', 'consultant'],
};

const addUserDefaultConfig = {

  title: "Add New User",
  addUser: {
    firstName: {
      title: "First Name",
      class: "col-12 form-group mb-4",
      inputType: "text"

    },
    lastName: {
      title: "Last Name",
      class: "col-12 form-group mb-4",
      inputType: "text"

    },
    username: {
      title: "User Name",
      class: "col-12 form-group mb-4",
      inputType: "text"

    },
    email: {
      title: "Email",
      class: "col-12 form-group mb-4",
      inputType: "email"

    },
    mobileNo: {
      title: "Mobile Number",
      class: "col-12 form-group mb-4",
      inputType: "text"
    },
    cancelBtn: {
      title: "Cancel"
    },
    addBtn: {
      title: "Add"
    }
  },
  placeHolder: {
    firstName: {
      label: "Enter First Name"
    },
    lastName: {
      label: "Enter Last Name"
    },
    userName: {
      label: "Enter User Name"
    },
    email: {
      label: "Email"
    },
    mobileNo: {
      label: "Enter mobile No"
    }
  }
}

export const USER_MGMT_DEFAULT_CONFIG_CNST = {
  ADD_USER_CONST: addUserDefaultConfig,
  INITIAL_COUNTRY_DATA : intialCountry
}

export const PROJECT_CONSTANTS = {
  APPLICATION_NAME: 'Kavach',
  USERMGMT_APP_NAME: 'User Management'
}

export const APPLICATION_TYPES = {
  AP_CRDA : 'Kavach',
  OTHER: 'Other',
}

